import { render, staticRenderFns } from "./PostEdit.vue?vue&type=template&id=83e15304&scoped=true&"
import script from "./PostEdit.vue?vue&type=script&lang=js&"
export * from "./PostEdit.vue?vue&type=script&lang=js&"
import style0 from "./PostEdit.vue?vue&type=style&index=0&id=83e15304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e15304",
  null
  
)

export default component.exports